export default __webpack_public_path__ + "static/media/icon_interactive_notebooks.7fe06ac8.png";